import React from 'react';
import styles from './PartnersStoreMenu.module.css';
import HorizontalFlex from 'layouts/flex/HorizontalFlex';
import FlexChild from 'layouts/flex/FlexChild';

/* 탭버튼 카테고리 */
const categories = [

    {
        name: 'calc',
        text: '정산 내역',
    },
    {
        name: 'stock',
        text: '재고관리',
    },
];

const PartnersStoreMenu = ({ category, onSelect }) => {
    return (
        <HorizontalFlex gap="1rem">
            {categories.map(c => (
                <FlexChild key={c.name}>
                    {' '}
                    {/* FlexChild에 key prop 추가 */}
                    <div
                        className={
                            category === c.name
                                ? styles.activeButton
                                : styles.button
                        }
                        onClick={() => onSelect(c.name)}
                    >
                        {c.text}
                    </div>
                </FlexChild>
            ))}
        </HorizontalFlex>
    );
};

export default PartnersStoreMenu;
